function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
ol-mapbox-style - Use Mapbox/MapLibre Style objects with OpenLayers
Copyright 2016-present ol-mapbox-style contributors
License: https://raw.githubusercontent.com/openlayers/ol-mapbox-style/master/LICENSE
*/

import { Color, CompoundExpression, convertFunction, createPropertyExpression, derefLayers, expressions, featureFilter as createFilter, isExpression, isFunction, v8 as spec } from '@maplibre/maplibre-gl-style-spec';
import mb2css from 'mapbox-to-css-font';
import Map from 'ol/Map.js';
import { distance } from 'ol/coordinate.js';
import { getCenter } from 'ol/extent.js';
import { toPromise } from 'ol/functions.js';
import RenderFeature from 'ol/render/Feature.js';
import Circle from 'ol/style/Circle.js';
import Fill from 'ol/style/Fill.js';
import Icon from 'ol/style/Icon.js';
import Stroke from 'ol/style/Stroke.js';
import Style from 'ol/style/Style.js';
import Text from 'ol/style/Text.js';
import { applyLetterSpacing, wrapText } from './text.js';
import { clearFunctionCache, createCanvas, defaultResolutions, deg2rad, drawIconHalo, drawSDF, emptyObj, getFilterCache, getFunctionCache, getStyleFunctionKey, getZoomForResolution } from './util.js';

/**
 * @typedef {import("ol/layer/Vector").default} VectorLayer
 * @typedef {import("ol/layer/VectorTile").default} VectorTileLayer
 * @typedef {import("ol/style/Style").StyleFunction} StyleFunction
 * @typedef {import('./util.js').ResourceType} ResourceType
 */

/** @typedef {string|Request|Response|Promise<string|Request|Response>|Object<string, string|Request|Response|Promise<string|Request|Response>>} SpriteImageUrl */

/**
 * @typedef {Object} SpriteImage
 * @property {HTMLImageElement|HTMLCanvasElement} image Image
 * @property {Array<number>} size Size
 * @property {boolean} [unSDFed] Image has been unSDFed
 */

/** @typedef {Object<string, SpriteImage>} SpriteImages */

var types = {
  'Point': 1,
  'MultiPoint': 1,
  'LineString': 2,
  'MultiLineString': 2,
  'Polygon': 3,
  'MultiPolygon': 3
};
var anchor = {
  'center': [0.5, 0.5],
  'left': [0, 0.5],
  'right': [1, 0.5],
  'top': [0.5, 0],
  'bottom': [0.5, 1],
  'top-left': [0, 0],
  'top-right': [1, 0],
  'bottom-left': [0, 1],
  'bottom-right': [1, 1]
};
var expressionData = function expressionData(rawExpression, propertySpec) {
  var compiledExpression = createPropertyExpression(rawExpression, propertySpec);
  if (compiledExpression.result === 'error') {
    throw new Error(compiledExpression.value.map(function (err) {
      return "".concat(err.key, ": ").concat(err.message);
    }).join(', '));
  }
  return compiledExpression.value;
};

// Shared camera object for global expression evaluation context
export var cameraObj = {
  zoom: 0,
  distanceFromCenter: 0
};

// Add unsupported expressions to the MapLibre GL Style spec
CompoundExpression.register(expressions, _objectSpread(_objectSpread({}, CompoundExpression.definitions), {}, {
  'pitch': [{
    kind: 'number'
  }, [], function (ctx) {
    return cameraObj.pitch || 90;
  }],
  'distance-from-center': [{
    kind: 'number'
  }, [], function (ctx) {
    return cameraObj.distanceFromCenter || 0;
  }]
}));
var renderFeatureCoordinates, renderFeature;

/**
 * @private
 * @param {Object} layer Gl object layer.
 * @param {string} layoutOrPaint 'layout' or 'paint'.
 * @param {string} property Feature property.
 * @param {Object} feature Gl feature.
 * @param {Object} [functionCache] Function cache.
 * @param {Object} [featureState] Feature state.
 * @return {?} Value.
 */
export function getValue(layer, layoutOrPaint, property, feature, functionCache, featureState) {
  var layerId = layer.id;
  if (!functionCache) {
    functionCache = {};
    console.warn('No functionCache provided to getValue()'); // eslint-disable-line no-console
  }
  if (!functionCache[layerId]) {
    functionCache[layerId] = {};
  }
  var functions = functionCache[layerId];
  if (!functions[property]) {
    var value = (layer[layoutOrPaint] || emptyObj)[property];
    var propertySpec = spec["".concat(layoutOrPaint, "_").concat(layer.type)][property];
    if (value === undefined) {
      value = propertySpec.default;
    }
    var isExpr = isExpression(value);
    if (!isExpr && isFunction(value)) {
      value = convertFunction(value, propertySpec);
      isExpr = true;
    }
    if (isExpr) {
      var compiledExpression = expressionData(value, propertySpec);
      functions[property] = compiledExpression.evaluate.bind(compiledExpression);
    } else {
      if (propertySpec.type == 'color') {
        value = Color.parse(value);
      }
      functions[property] = function () {
        return value;
      };
    }
  }
  return functions[property](cameraObj, feature, featureState);
}

/**
 * @private
 * @param {Object} layer Gl object layer.
 * @param {Object} feature Gl feature.
 * @param {"icon"|"text"} prefix Style property prefix.
 * @param {Object} [functionCache] Function cache.
 * @return {"declutter"|"obstacle"|"none"} Value.
 */
function getDeclutterMode(layer, feature, prefix, functionCache) {
  var allowOverlap = getValue(layer, 'layout', "".concat(prefix, "-allow-overlap"), feature, functionCache);
  if (!allowOverlap) {
    return 'declutter';
  }
  var ignorePlacement = getValue(layer, 'layout', "".concat(prefix, "-ignore-placement"), feature, functionCache);
  if (!ignorePlacement) {
    return 'obstacle';
  }
  return 'none';
}

/**
 * @private
 * @param {string} layerId Layer id.
 * @param {?} filter Filter.
 * @param {Object} feature Feature.
 * @param {Object} [filterCache] Filter cache.
 * @return {boolean} Filter result.
 */
function evaluateFilter(layerId, filter, feature, filterCache) {
  if (!filterCache) {
    console.warn('No filterCache provided to evaluateFilter()'); // eslint-disable-line no-console
  }
  if (!(layerId in filterCache)) {
    try {
      filterCache[layerId] = createFilter(filter).filter;
    } catch (e) {
      console.warn('Filter will evaluate to false: ' + e.message); // eslint-disable-line no-console
      filterCache[layerId] = function () {
        return false;
      };
    }
  }
  return filterCache[layerId](cameraObj, feature);
}
var renderTransparentEnabled = false;

/**
 * Configure whether features with a transparent style should be rendered. When
 * set to `true`, it will be possible to hit detect content that is not visible,
 * like transparent fills of polygons, using `ol/layer/Layer#getFeatures()` or
 * `ol/Map#getFeaturesAtPixel()`
 * @param {boolean} enabled Rendering of transparent elements is enabled.
 * Default is `false`.
 */
export function renderTransparent(enabled) {
  if (enabled !== renderTransparentEnabled) {
    clearFunctionCache();
    renderTransparentEnabled = enabled;
  }
}

/**
 * @private
 * @param {?} color Color.
 * @param {number} [opacity] Opacity.
 * @return {string} Color.
 */
function colorWithOpacity(color, opacity) {
  if (color) {
    if (!renderTransparentEnabled && (color.a === 0 || opacity === 0)) {
      return undefined;
    }
    var a = color.a;
    opacity = opacity === undefined ? 1 : opacity;
    return a === 0 ? 'transparent' : 'rgba(' + Math.round(color.r * 255 / a) + ',' + Math.round(color.g * 255 / a) + ',' + Math.round(color.b * 255 / a) + ',' + a * opacity + ')';
  }
  return color;
}
var templateRegEx = /\{[^{}}]*\}/g;

/**
 * @private
 * @param {string} text Text.
 * @param {Object} properties Properties.
 * @return {string} Text.
 */
function fromTemplate(text, properties) {
  return text.replace(templateRegEx, function (match) {
    return properties[match.slice(1, -1)] || '';
  });
}

/**
 * @private
 * @param {string} icon Icon identifier (with prefix if not 'default')
 * @param {SpriteImages} spriteImages Sprite images.
 * @return {SpriteImage} Image.
 */
export function getSpriteImageForIcon(icon, spriteImages) {
  var prefix = icon.split(':')[0];
  if (prefix === icon) {
    prefix = 'default';
  }
  return spriteImages[prefix];
}
var recordLayer = false;

/**
 * Turns recording of the Mapbox/MapLibre Style's `layer` on and off. When turned on,
 * the layer that a rendered feature belongs to will be set as the feature's
 * `mapbox-layer` property.
 * @param {boolean} record Recording of the style layer is on.
 */
export function recordStyleLayer() {
  var record = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  recordLayer = record;
}
export var styleFunctionArgs = {};

/**
 * **Caution**: This is a low level API, which is only useful for advanced use cases.
 * If you want to crete a map or layer group from an entire Mapbox/MapLibre style, use
 * the `apply()` function. If you want to create a vector layer from a single
 * source of a Mapbox/MapLibre style, use the `applyStyle()` function. If you want to
 * create a vector tile layer from a single source of a Mapbox/MapLibre style, use either
 * the `applyStyle()` function or the `MapboxVectorLayer` constructor.
 *
 * Creates a style function from the `glStyle` object for all layers that use
 * the specified `source`, which needs to be a `"type": "vector"` or
 * `"type": "geojson"` source and applies it to the specified OpenLayers layer.
 *
 * Two additional properties will be set on the provided layer:
 *
 *  * `mapbox-source`: The `id` of the Mapbox/MapLibre Style document's source that the
 *    OpenLayers layer was created from. Usually `apply()` creates one
 *    OpenLayers layer per Mapbox/MapLibre Style source, unless the layer stack has
 *    layers from different sources in between.
 *  * `mapbox-layers`: The `id`s of the Mapbox/MapLibre Style document's layers that are
 *    included in the OpenLayers layer.
 *
 * This function also works in a web worker. In worker mode, the main thread needs
 * to listen to messages from the worker and respond with another message to make
 * sure that sprite image loading works:
 *
 * ```js
 *  worker.addEventListener('message', event => {
 *   if (event.data.action === 'loadImage') {
 *     const image = new Image();
 *     image.crossOrigin = 'anonymous';
 *     image.addEventListener('load', function() {
 *       createImageBitmap(image, 0, 0, image.width, image.height).then(imageBitmap => {
 *         worker.postMessage({
 *           action: 'imageLoaded',
 *           image: imageBitmap,
 *           src: event.data.src
 *         }, [imageBitmap]);
 *       });
 *     });
 *     image.src = event.data.src;
 *   }
 * });
 * ```
 *
 * @param {VectorLayer|VectorTileLayer} olLayer OpenLayers layer to
 * apply the style to. In addition to the style, the layer will get two
 * properties: `mapbox-source` will be the `id` of the `glStyle`'s source used
 * for the layer, and `mapbox-layers` will be an array of the `id`s of the
 * `glStyle`'s layers.
 * @param {string|Object} glStyle Mapbox/MapLibre Style object.
 * @param {string|Array<string>} sourceOrLayers `source` key or an array of layer `id`s
 * from the Mapbox/MapLibre Style object. When a `source` key is provided, all layers for
 * the specified source will be included in the style function. When layer `id`s
 * are provided, they must be from layers that use the same source.
 * @param {Array<number>} resolutions
 * Resolutions for mapping resolution to zoom level.
 * @param {Object} spriteData Sprite data from the url specified in
 * the Mapbox/MapLibre Style object's `sprite` property. Only required if a `sprite`
 * property is specified in the Mapbox/MapLibre Style object.
 * @param {SpriteImageUrl} spriteImageUrl Sprite image url for the sprite
 * specified in the Mapbox/MapLibre Style object's `sprite` property. Only required if a
 * `sprite` property is specified in the Mapbox/MapLibre Style object. If multiple `sprite`s
 * are defined in the style object, this has to be an object with the sprite id as key and the
 * sprite image URL as value.
 * @param {function(Array<string>, string=):Array<string>} getFonts Function that
 * receives a font stack and the url template from the GL style's `metadata['ol:webfonts']`
 * property (if set) as arguments, and returns a (modified) font stack that
 * is available. Font names are the names used in the Mapbox/MapLibre Style object. If
 * not provided, the font stack will be used as-is. This function can also be
 * used for loading web fonts.
 * @param {function(VectorLayer|VectorTileLayer, string):HTMLImageElement|HTMLCanvasElement|string|undefined} [getImage]
 * Function that returns an image or a URL for an image name. If the result is an HTMLImageElement, it must already be
 * loaded. The layer can be used to call layer.changed() when the loading and processing of the image has finished.
 * This function can be used for icons not in the sprite or to override sprite icons.
 * @return {StyleFunction} Style function for use in
 * `ol.layer.Vector` or `ol.layer.VectorTile`.
 */
export function stylefunction(olLayer, glStyle, sourceOrLayers) {
  var resolutions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultResolutions;
  var spriteData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
  var spriteImageUrl = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
  var getFonts = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : undefined;
  var getImage = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : undefined;
  if (typeof glStyle == 'string') {
    glStyle = JSON.parse(glStyle);
  }
  if (glStyle.version != 8) {
    throw new Error('glStyle version 8 required.');
  }
  styleFunctionArgs[getStyleFunctionKey(glStyle, olLayer)] = Array.from(arguments);

  /** @type {SpriteImages} */
  var spriteImages = {};
  if (typeof spriteImageUrl === 'string' || spriteImageUrl instanceof Request || spriteImageUrl instanceof Response || spriteImageUrl instanceof Promise) {
    spriteImageUrl = {
      'default': spriteImageUrl
    };
  }
  var _loop = function _loop(prefix) {
    var imageUrl = spriteImageUrl[prefix];
    toPromise(function () {
      return imageUrl;
    }).then(/*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(imageUrl) {
        var blobUrl, img, response, blob, worker;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(typeof Image !== 'undefined')) {
                _context.n = 7;
                break;
              }
              img = new Image();
              if (!(typeof imageUrl === 'string')) {
                _context.n = 1;
                break;
              }
              img.crossOrigin = 'anonymous';
              img.src = imageUrl;
              _context.n = 6;
              break;
            case 1:
              if (!(imageUrl instanceof Request)) {
                _context.n = 3;
                break;
              }
              _context.n = 2;
              return fetch(imageUrl);
            case 2:
              response = _context.v;
              _context.n = 4;
              break;
            case 3:
              if (imageUrl instanceof Response) {
                response = imageUrl;
              }
            case 4:
              _context.n = 5;
              return response.blob();
            case 5:
              blob = _context.v;
              blobUrl = URL.createObjectURL(blob);
              img.src = blobUrl;
            case 6:
              img.addEventListener('load', function load() {
                img.removeEventListener('load', load);
                spriteImages[prefix] = {
                  image: img,
                  size: [img.width, img.height]
                };
                olLayer.changed();
                if (blobUrl) {
                  URL.revokeObjectURL(blobUrl);
                }
              });
              img.addEventListener('error', function error() {
                URL.revokeObjectURL(blobUrl);
                img.removeEventListener('error', error);
              });
              _context.n = 8;
              break;
            case 7:
              if (typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope // eslint-disable-line
              ) {
                worker = /** @type {*} */self; // Main thread needs to handle 'loadImage' and dispatch 'imageLoaded'
                worker.postMessage({
                  action: 'loadImage',
                  src: imageUrl
                });
                worker.addEventListener('message', function handler(event) {
                  if (event.data.action === 'imageLoaded' && event.data.src === imageUrl) {
                    spriteImages[prefix] = {
                      image: event.data.image,
                      size: [event.data.image.width, event.data.image.height]
                    };
                  }
                });
              }
            case 8:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  };
  for (var prefix in spriteImageUrl) {
    _loop(prefix);
  }
  var allLayers = derefLayers(glStyle.layers);
  var layersBySourceLayer = {};
  var mapboxLayers = [];
  var iconImageCache = {};
  var patternCache = {};
  var functionCache = getFunctionCache(glStyle);
  var filterCache = getFilterCache(glStyle);
  var mapboxSource;
  for (var i = 0, ii = allLayers.length; i < ii; ++i) {
    var layer = allLayers[i];
    var layerId = layer.id;
    if (typeof sourceOrLayers == 'string' && layer.source == sourceOrLayers || Array.isArray(sourceOrLayers) && sourceOrLayers.indexOf(layerId) !== -1) {
      var sourceLayer = layer['source-layer'];
      if (!mapboxSource) {
        mapboxSource = layer.source;
        var source = glStyle.sources[mapboxSource];
        if (!source) {
          throw new Error("Source \"".concat(mapboxSource, "\" is not defined"));
        }
        var type = source.type;
        if (type !== 'vector' && type !== 'geojson') {
          throw new Error("Source \"".concat(mapboxSource, "\" is not of type \"vector\" or \"geojson\", but \"").concat(type, "\""));
        }
      } else if (layer.source !== mapboxSource) {
        throw new Error("Layer \"".concat(layerId, "\" does not use source \"").concat(mapboxSource));
      }
      var layers = layersBySourceLayer[sourceLayer];
      if (!layers) {
        layers = [];
        layersBySourceLayer[sourceLayer] = layers;
      }
      layers.push({
        layer: layer,
        index: i
      });
      mapboxLayers.push(layerId);
    }
  }
  var textHalo = new Stroke();
  var textColor = new Fill();
  var styles = [];

  /**
   * @param {import("ol/Feature").default|import("ol/render/Feature").default} feature Feature.
   * @param {number} resolution Resolution.
   * @param {string} [onlyLayer] Calculate style for this layer only.
   * @return {Array<import("ol/style/Style").default>} Style.
   */
  var styleFunction = function styleFunction(feature, resolution, onlyLayer) {
    var _olLayer$getSource$fo, _olLayer$getSource;
    var layerProperty = //@ts-ignore
    (_olLayer$getSource$fo = (_olLayer$getSource = olLayer.getSource) === null || _olLayer$getSource === void 0 || (_olLayer$getSource = _olLayer$getSource.call(olLayer)) === null || _olLayer$getSource === void 0 || (_olLayer$getSource = _olLayer$getSource.format_) === null || _olLayer$getSource === void 0 ? void 0 : _olLayer$getSource.layerName_) !== null && _olLayer$getSource$fo !== void 0 ? _olLayer$getSource$fo : 'mvt:layer';
    var properties = feature.getProperties();
    var layers = layersBySourceLayer[properties[layerProperty]];
    if (!layers) {
      return undefined;
    }
    var zoom = resolutions.indexOf(resolution);
    if (zoom == -1) {
      zoom = getZoomForResolution(resolution, resolutions);
    }
    cameraObj.zoom = zoom;
    cameraObj.distanceFromCenter = 0;
    var featureGeometry = feature.getGeometry();
    var type = types[featureGeometry.getType()];
    var map = olLayer.get('map');
    if (map && map instanceof Map && type === 1) {
      var size = map.getSize();
      if (size) {
        var mapCenter = map.getView().getCenter();
        var featureCenter = getCenter(featureGeometry.getExtent());
        cameraObj.distanceFromCenter = distance(mapCenter, featureCenter) / resolution / size[1];
      }
    }
    var f = {
      id: feature.getId(),
      properties: properties,
      type: type
    };
    var featureState = olLayer.get('mapbox-featurestate')[feature.getId()];
    var stylesLength = -1;
    var featureBelongsToLayer;
    var _loop2 = function _loop2() {
        var layerData = layers[_i];
        var layer = layerData.layer;
        var layerId = layer.id;
        if (onlyLayer !== undefined && onlyLayer !== layerId) {
          return 0; // continue
        }
        var layout = layer.layout || emptyObj;
        var paint = layer.paint || emptyObj;
        if (layout.visibility === 'none' || 'minzoom' in layer && zoom < layer.minzoom || 'maxzoom' in layer && zoom >= layer.maxzoom) {
          return 0; // continue
        }
        var filter = layer.filter;
        if (!filter || evaluateFilter(layerId, filter, f, filterCache)) {
          featureBelongsToLayer = layer;
          var color, opacity, fill, stroke, strokeColor, style;
          var index = layerData.index;
          if (type == 3 && (layer.type == 'fill' || layer.type == 'fill-extrusion')) {
            opacity = getValue(layer, 'paint', layer.type + '-opacity', f, functionCache, featureState);
            if (layer.type + '-pattern' in paint) {
              var fillIcon = getValue(layer, 'paint', layer.type + '-pattern', f, functionCache, featureState);
              if (fillIcon) {
                var _icon = typeof fillIcon === 'string' ? fromTemplate(fillIcon, properties) : fillIcon.toString();
                var spriteImage = getSpriteImageForIcon(_icon, spriteImages);
                if (spriteData && spriteData[_icon] && spriteImage) {
                  ++stylesLength;
                  style = styles[stylesLength];
                  if (!style || !style.getFill() || style.getStroke() || style.getText()) {
                    style = new Style({
                      fill: new Fill()
                    });
                    styles[stylesLength] = style;
                  }
                  fill = style.getFill();
                  style.setZIndex(index);
                  var icon_cache_key = _icon + '.' + opacity;
                  var pattern = patternCache[icon_cache_key];
                  if (!pattern) {
                    var spriteImageData = spriteData[_icon];
                    var canvas = createCanvas(spriteImageData.width, spriteImageData.height);
                    var ctx = /** @type {CanvasRenderingContext2D} */
                    canvas.getContext('2d');
                    ctx.globalAlpha = opacity;
                    ctx.drawImage(spriteImage.image, spriteImageData.x, spriteImageData.y, spriteImageData.width, spriteImageData.height, 0, 0, spriteImageData.width, spriteImageData.height);
                    pattern = ctx.createPattern(canvas, 'repeat');
                    patternCache[icon_cache_key] = pattern;
                  }
                  fill.setColor(pattern);
                }
              }
            } else {
              color = colorWithOpacity(getValue(layer, 'paint', layer.type + '-color', f, functionCache, featureState), opacity);
              if (layer.type + '-outline-color' in paint) {
                strokeColor = colorWithOpacity(getValue(layer, 'paint', layer.type + '-outline-color', f, functionCache, featureState), opacity);
              }
              if (!strokeColor) {
                strokeColor = color;
              }
              if (color || strokeColor) {
                ++stylesLength;
                style = styles[stylesLength];
                if (!style || color && !style.getFill() || !color && style.getFill() || strokeColor && !style.getStroke() || !strokeColor && style.getStroke() || style.getText()) {
                  style = new Style({
                    fill: color ? new Fill() : undefined,
                    stroke: strokeColor ? new Stroke() : undefined
                  });
                  styles[stylesLength] = style;
                }
                if (color) {
                  fill = style.getFill();
                  fill.setColor(color);
                }
                if (strokeColor) {
                  stroke = style.getStroke();
                  stroke.setColor(strokeColor);
                  stroke.setWidth(0.5);
                }
                style.setZIndex(index);
              }
            }
          }
          if (type != 1 && layer.type == 'line') {
            if (!('line-pattern' in paint)) {
              color = colorWithOpacity(getValue(layer, 'paint', 'line-color', f, functionCache, featureState), getValue(layer, 'paint', 'line-opacity', f, functionCache, featureState));
            } else {
              color = undefined;
            }
            var width = getValue(layer, 'paint', 'line-width', f, functionCache, featureState);
            if (color && width > 0) {
              ++stylesLength;
              style = styles[stylesLength];
              if (!style || !style.getStroke() || style.getFill() || style.getText()) {
                style = new Style({
                  stroke: new Stroke()
                });
                styles[stylesLength] = style;
              }
              stroke = style.getStroke();
              stroke.setLineCap(getValue(layer, 'layout', 'line-cap', f, functionCache, featureState));
              stroke.setLineJoin(getValue(layer, 'layout', 'line-join', f, functionCache, featureState));
              stroke.setMiterLimit(getValue(layer, 'layout', 'line-miter-limit', f, functionCache, featureState));
              stroke.setColor(color);
              stroke.setWidth(width);
              stroke.setLineDash(paint['line-dasharray'] ? getValue(layer, 'paint', 'line-dasharray', f, functionCache, featureState).map(function (x) {
                return x * width;
              }) : null);
              style.setZIndex(index);
            }
          }
          var hasImage = false;
          var text = null;
          var placementAngle = 0;
          var icon, iconImg, skipLabel;
          if ((type == 1 || type == 2) && 'icon-image' in layout) {
            var iconImage = getValue(layer, 'layout', 'icon-image', f, functionCache, featureState);
            if (iconImage) {
              icon = typeof iconImage === 'string' ? fromTemplate(iconImage, properties) : iconImage.toString();
              var styleGeom = undefined;
              var imageElement = getImage ? getImage(olLayer, icon) : undefined;
              var _spriteImage = getSpriteImageForIcon(icon, spriteImages);
              if (spriteData && spriteData[icon] && _spriteImage || imageElement) {
                var iconRotationAlignment = getValue(layer, 'layout', 'icon-rotation-alignment', f, functionCache, featureState);
                if (type == 2) {
                  var geom = /** @type {*} */feature.getGeometry();
                  // ol package and ol-debug.js only
                  if (geom.getFlatMidpoint || geom.getFlatMidpoints) {
                    var extent = geom.getExtent();
                    var _size = Math.sqrt(Math.max(Math.pow((extent[2] - extent[0]) / resolution, 2), Math.pow((extent[3] - extent[1]) / resolution, 2)));
                    if (_size > 150) {
                      //FIXME Do not hard-code a size of 150
                      var midpoint = geom.getType() === 'MultiLineString' ? geom.getFlatMidpoints() : geom.getFlatMidpoint();
                      if (!renderFeature) {
                        renderFeatureCoordinates = [NaN, NaN];
                        renderFeature = new RenderFeature('Point', renderFeatureCoordinates, [], 2, {}, undefined);
                      }
                      styleGeom = renderFeature;
                      renderFeatureCoordinates[0] = midpoint[0];
                      renderFeatureCoordinates[1] = midpoint[1];
                      var placement = getValue(layer, 'layout', 'symbol-placement', f, functionCache, featureState);
                      if (placement === 'line' && iconRotationAlignment === 'map') {
                        var stride = geom.getStride();
                        var coordinates = geom.getFlatCoordinates();
                        for (var _i2 = 0, _ii2 = coordinates.length - stride; _i2 < _ii2; _i2 += stride) {
                          var x1 = coordinates[_i2];
                          var y1 = coordinates[_i2 + 1];
                          var x2 = coordinates[_i2 + stride];
                          var y2 = coordinates[_i2 + stride + 1];
                          var minX = Math.min(x1, x2);
                          var maxX = Math.max(x1, x2);
                          var xM = midpoint[0];
                          var yM = midpoint[1];
                          var dotProduct = (y2 - y1) * (xM - x1) - (x2 - x1) * (yM - y1);
                          if (Math.abs(dotProduct) < 0.001 &&
                          //midpoint is aligned with the segment
                          xM <= maxX && xM >= minX //midpoint is on the segment and not outside it
                          ) {
                            placementAngle = Math.atan2(y1 - y2, x2 - x1);
                            break;
                          }
                        }
                      }
                    }
                  }
                }
                if (type !== 2 || styleGeom) {
                  var iconSize = getValue(layer, 'layout', 'icon-size', f, functionCache, featureState);
                  var iconColor = paint['icon-color'] !== undefined ? getValue(layer, 'paint', 'icon-color', f, functionCache, featureState) : null;
                  if (!iconColor || iconColor.a !== 0) {
                    var haloColor = getValue(layer, 'paint', 'icon-halo-color', f, functionCache, featureState);
                    var haloWidth = getValue(layer, 'paint', 'icon-halo-width', f, functionCache, featureState);
                    var iconCacheKey = "".concat(icon, ".").concat(iconSize, ".").concat(haloWidth, ".").concat(haloColor);
                    if (iconColor !== null) {
                      iconCacheKey += ".".concat(iconColor);
                    }
                    iconImg = iconImageCache[iconCacheKey];
                    if (!iconImg) {
                      var declutterMode = getDeclutterMode(layer, f, 'icon', functionCache);
                      var displacement;
                      if ('icon-offset' in layout) {
                        displacement = getValue(layer, 'layout', 'icon-offset', f, functionCache, featureState).slice(0);
                        displacement[0] *= iconSize;
                        displacement[1] *= -iconSize;
                      }
                      var _color = iconColor ? [iconColor.r * 255, iconColor.g * 255, iconColor.b * 255, iconColor.a] : undefined;
                      if (imageElement) {
                        var iconOptions = {
                          color: _color,
                          rotateWithView: iconRotationAlignment === 'map',
                          displacement: displacement,
                          declutterMode: declutterMode,
                          scale: iconSize
                        };
                        if (typeof imageElement === 'string') {
                          // it is a src URL
                          iconOptions.src = imageElement;
                        } else {
                          iconOptions.img = imageElement;
                          iconOptions.imgSize = [imageElement.width, imageElement.height];
                        }
                        iconImg = new Icon(iconOptions);
                      } else {
                        var _spriteImageData = spriteData[icon];
                        var img, _size2, offset;
                        if (haloWidth) {
                          if (_spriteImageData.sdf) {
                            img = drawIconHalo(drawSDF(_spriteImage.image, _spriteImageData, iconColor || [0, 0, 0, 1]), {
                              x: 0,
                              y: 0,
                              width: _spriteImageData.width,
                              height: _spriteImageData.height,
                              pixelRatio: _spriteImageData.pixelRatio
                            }, haloWidth, haloColor);
                            _color = undefined; // do not tint haloed icons
                          } else {
                            img = drawIconHalo(_spriteImage.image, _spriteImageData, haloWidth, haloColor);
                          }
                        } else {
                          if (_spriteImageData.sdf) {
                            if (!_spriteImage.unSDFed) {
                              var spriteImageUnSDFed = drawSDF(_spriteImage.image, {
                                x: 0,
                                y: 0,
                                width: _spriteImage.size[0],
                                height: _spriteImage.size[1]
                              }, {
                                r: 1,
                                g: 1,
                                b: 1,
                                a: 1
                              });
                              _spriteImage.image = spriteImageUnSDFed;
                              _spriteImage.unSDFed = true;
                            }
                          }
                          img = _spriteImage.image;
                          _size2 = [_spriteImageData.width, _spriteImageData.height];
                          offset = [_spriteImageData.x, _spriteImageData.y];
                        }
                        iconImg = new Icon({
                          color: _color,
                          img: img,
                          // @ts-ignore
                          imgSize: _spriteImage.size,
                          size: _size2,
                          offset: offset,
                          rotateWithView: iconRotationAlignment === 'map',
                          scale: iconSize / _spriteImageData.pixelRatio,
                          displacement: displacement,
                          declutterMode: declutterMode
                        });
                      }
                      iconImageCache[iconCacheKey] = iconImg;
                    }
                  }
                  if (iconImg) {
                    ++stylesLength;
                    style = styles[stylesLength];
                    if (!style || !style.getImage() || style.getFill() || style.getStroke()) {
                      style = new Style();
                      styles[stylesLength] = style;
                    }
                    style.setGeometry(styleGeom);
                    iconImg.setRotation(placementAngle + deg2rad(getValue(layer, 'layout', 'icon-rotate', f, functionCache, featureState)));
                    iconImg.setOpacity(getValue(layer, 'paint', 'icon-opacity', f, functionCache, featureState));
                    iconImg.setAnchor(anchor[getValue(layer, 'layout', 'icon-anchor', f, functionCache, featureState)]);
                    style.setImage(iconImg);
                    text = style.getText();
                    style.setText(undefined);
                    style.setZIndex(index);
                    hasImage = true;
                    skipLabel = false;
                  }
                } else {
                  skipLabel = true;
                }
              }
            }
          }
          if (type == 1 && layer.type === 'circle') {
            ++stylesLength;
            style = styles[stylesLength];
            if (!style || !style.getImage() || style.getFill() || style.getStroke()) {
              style = new Style();
              styles[stylesLength] = style;
            }
            var circleRadius = 'circle-radius' in paint ? getValue(layer, 'paint', 'circle-radius', f, functionCache, featureState) : 5;
            var circleStrokeColor = colorWithOpacity(getValue(layer, 'paint', 'circle-stroke-color', f, functionCache, featureState), getValue(layer, 'paint', 'circle-stroke-opacity', f, functionCache, featureState));
            var circleTranslate = getValue(layer, 'paint', 'circle-translate', f, functionCache, featureState);
            var circleColor = colorWithOpacity(getValue(layer, 'paint', 'circle-color', f, functionCache, featureState), getValue(layer, 'paint', 'circle-opacity', f, functionCache, featureState));
            var circleStrokeWidth = getValue(layer, 'paint', 'circle-stroke-width', f, functionCache, featureState);
            var cache_key = circleRadius + '.' + circleStrokeColor + '.' + circleColor + '.' + circleStrokeWidth + '.' + circleTranslate[0] + '.' + circleTranslate[1];
            iconImg = iconImageCache[cache_key];
            if (!iconImg) {
              iconImg = new Circle({
                radius: circleRadius,
                displacement: [circleTranslate[0], -circleTranslate[1]],
                stroke: circleStrokeColor && circleStrokeWidth > 0 ? new Stroke({
                  width: circleStrokeWidth,
                  color: circleStrokeColor
                }) : undefined,
                fill: circleColor ? new Fill({
                  color: circleColor
                }) : undefined,
                declutterMode: 'none'
              });
              iconImageCache[cache_key] = iconImg;
            }
            style.setImage(iconImg);
            text = style.getText();
            style.setText(undefined);
            style.setGeometry(undefined);
            style.setZIndex(index);
            hasImage = true;
          }
          var label, font, textLineHeight, textSize, letterSpacing, maxTextWidth;
          if ('text-field' in layout) {
            textSize = Math.round(getValue(layer, 'layout', 'text-size', f, functionCache, featureState));
            var fontArray = getValue(layer, 'layout', 'text-font', f, functionCache, featureState);
            textLineHeight = getValue(layer, 'layout', 'text-line-height', f, functionCache, featureState);
            font = mb2css(getFonts ? getFonts(fontArray, glStyle.metadata ? glStyle.metadata['ol:webfonts'] : undefined) : fontArray, textSize, textLineHeight);
            if (!font.includes('sans-serif')) {
              font += ',sans-serif';
            }
            letterSpacing = getValue(layer, 'layout', 'text-letter-spacing', f, functionCache, featureState);
            maxTextWidth = getValue(layer, 'layout', 'text-max-width', f, functionCache, featureState);
            var textField = getValue(layer, 'layout', 'text-field', f, functionCache, featureState);
            if (_typeof(textField) === 'object' && textField.sections) {
              if (textField.sections.length === 1) {
                label = textField.toString();
              } else {
                label = textField.sections.reduce(function (acc, chunk, i) {
                  var fonts = chunk.fontStack ? chunk.fontStack.split(',') : fontArray;
                  var chunkFont = mb2css(getFonts ? getFonts(fonts) : fonts, textSize * (chunk.scale || 1), textLineHeight);
                  var text = chunk.text;
                  if (text === '\n') {
                    acc.push('\n', '');
                    return acc;
                  }
                  if (type == 2) {
                    acc.push(applyLetterSpacing(text, letterSpacing), chunkFont);
                    return acc;
                  }
                  text = wrapText(text, chunkFont, maxTextWidth, letterSpacing).split('\n');
                  for (var _i3 = 0, _ii3 = text.length; _i3 < _ii3; ++_i3) {
                    if (_i3 > 0) {
                      acc.push('\n', '');
                    }
                    acc.push(text[_i3], chunkFont);
                  }
                  return acc;
                }, []);
              }
            } else {
              label = fromTemplate(textField, properties).trim();
            }
            opacity = getValue(layer, 'paint', 'text-opacity', f, functionCache, featureState);
          }
          if (label && opacity && !skipLabel) {
            if (!hasImage) {
              ++stylesLength;
              style = styles[stylesLength];
              if (!style || !style.getText() || style.getFill() || style.getStroke()) {
                style = new Style();
                styles[stylesLength] = style;
              }
              style.setImage(undefined);
              style.setGeometry(undefined);
            }
            var _declutterMode = getDeclutterMode(layer, f, 'text', functionCache);
            if (!style.getText()) {
              style.setText(text);
            }
            text = style.getText();
            if (!text || 'getDeclutterMode' in text && text.getDeclutterMode() !== _declutterMode) {
              text = new Text({
                padding: [2, 2, 2, 2],
                // @ts-ignore
                declutterMode: _declutterMode
              });
              style.setText(text);
            }
            var textTransform = getValue(layer, 'layout', 'text-transform', f, functionCache, featureState);
            if (textTransform == 'uppercase') {
              label = Array.isArray(label) ? label.map(function (t, i) {
                return i % 2 ? t : t.toUpperCase();
              }) : label.toUpperCase();
            } else if (textTransform == 'lowercase') {
              label = Array.isArray(label) ? label.map(function (t, i) {
                return i % 2 ? t : t.toLowerCase();
              }) : label.toLowerCase();
            }
            var wrappedLabel = Array.isArray(label) ? label : type == 2 ? applyLetterSpacing(label, letterSpacing) : wrapText(label, font, maxTextWidth, letterSpacing);
            text.setText(wrappedLabel);
            text.setFont(font);
            text.setRotation(deg2rad(getValue(layer, 'layout', 'text-rotate', f, functionCache, featureState)));
            if (typeof text.setKeepUpright === 'function') {
              var keepUpright = getValue(layer, 'layout', 'text-keep-upright', f, functionCache, featureState);
              text.setKeepUpright(keepUpright);
            }
            var textAnchor = getValue(layer, 'layout', 'text-anchor', f, functionCache, featureState);
            var _placement = hasImage || type == 1 ? 'point' : getValue(layer, 'layout', 'symbol-placement', f, functionCache, featureState);
            var textAlign;
            if (_placement === 'line-center') {
              text.setPlacement('line');
              textAlign = 'center';
            } else {
              text.setPlacement(_placement);
            }
            if (_placement === 'line' && typeof text.setRepeat === 'function') {
              var symbolSpacing = getValue(layer, 'layout', 'symbol-spacing', f, functionCache, featureState);
              text.setRepeat(symbolSpacing * 2);
            }
            text.setOverflow(_placement === 'point');
            var textHaloWidth = getValue(layer, 'paint', 'text-halo-width', f, functionCache, featureState);
            var textOffset = getValue(layer, 'layout', 'text-offset', f, functionCache, featureState);
            var textTranslate = getValue(layer, 'paint', 'text-translate', f, functionCache, featureState);
            // Text offset has to take halo width and line height into account
            var vOffset = 0;
            var hOffset = 0;
            if (_placement == 'point') {
              textAlign = 'center';
              if (textAnchor.indexOf('left') !== -1) {
                textAlign = 'left';
                hOffset = textHaloWidth;
              } else if (textAnchor.indexOf('right') !== -1) {
                textAlign = 'right';
                hOffset = -textHaloWidth;
              }
              var textRotationAlignment = getValue(layer, 'layout', 'text-rotation-alignment', f, functionCache, featureState);
              text.setRotateWithView(textRotationAlignment == 'map');
            } else {
              text.setMaxAngle(deg2rad(getValue(layer, 'layout', 'text-max-angle', f, functionCache, featureState)) * label.length / wrappedLabel.length);
              text.setRotateWithView(false);
            }
            text.setTextAlign(textAlign);
            var textBaseline = 'middle';
            if (textAnchor.indexOf('bottom') == 0) {
              textBaseline = 'bottom';
              vOffset = -textHaloWidth - 0.5 * (textLineHeight - 1) * textSize;
            } else if (textAnchor.indexOf('top') == 0) {
              textBaseline = 'top';
              vOffset = textHaloWidth + 0.5 * (textLineHeight - 1) * textSize;
            }
            text.setTextBaseline(textBaseline);
            var textJustify = getValue(layer, 'layout', 'text-justify', f, functionCache, featureState);
            text.setJustify(textJustify === 'auto' ? undefined : textJustify);
            text.setOffsetX(textOffset[0] * textSize + hOffset + textTranslate[0]);
            text.setOffsetY(textOffset[1] * textSize + vOffset + textTranslate[1]);
            textColor.setColor(colorWithOpacity(getValue(layer, 'paint', 'text-color', f, functionCache, featureState), opacity));
            text.setFill(textColor);
            var _haloColor = colorWithOpacity(getValue(layer, 'paint', 'text-halo-color', f, functionCache, featureState), opacity);
            if (_haloColor && textHaloWidth > 0) {
              textHalo.setColor(_haloColor);
              // spec here : https://docs.mapbox.com/mapbox-gl-js/style-spec/#paint-symbol-text-halo-width
              // Halo width must be doubled because it is applied around the center of the text outline
              textHaloWidth *= 2;
              // 1/4 of text size (spec) x 2
              var halfTextSize = 0.5 * textSize;
              textHalo.setWidth(textHaloWidth <= halfTextSize ? textHaloWidth : halfTextSize);
              text.setStroke(textHalo);
            } else {
              text.setStroke(undefined);
            }
            var textPadding = getValue(layer, 'layout', 'text-padding', f, functionCache, featureState);
            var padding = text.getPadding();
            if (textPadding !== padding[0]) {
              padding[0] = textPadding;
              padding[1] = textPadding;
              padding[2] = textPadding;
              padding[3] = textPadding;
            }
            style.setZIndex(index);
          }
        }
      },
      _ret;
    for (var _i = 0, _ii = layers.length; _i < _ii; ++_i) {
      _ret = _loop2();
      if (_ret === 0) continue;
    }
    if (stylesLength > -1) {
      styles.length = stylesLength + 1;
      if (recordLayer) {
        if ('set' in feature) {
          // ol/Feature
          feature.set('mapbox-layer', featureBelongsToLayer);
        } else {
          // ol/render/Feature
          feature.getProperties()['mapbox-layer'] = featureBelongsToLayer;
        }
      }
      return styles;
    }
    return undefined;
  };
  olLayer.setStyle(styleFunction);
  olLayer.set('mapbox-layers', mapboxLayers);
  olLayer.set('mapbox-source', mapboxSource);
  olLayer.set('mapbox-featurestate', olLayer.get('mapbox-featurestate') || {});
  return styleFunction;
}

/**
 * Get the the style for a specific Mapbox layer only. This can be useful for creating a legend.
 * @param {import("ol/Feature").default|import("ol/render/Feature").default} feature OpenLayers feature.
 * @param {number} resolution View resolution.
 * @param {import("ol/layer").Vector|import("ol/layer").VectorTile} olLayer OpenLayers layer.
 * @param {string} layerId Id of the Mapbox layer to get the style for
 * @return {Array<import("ol/style").Style>} Styles for the provided Mapbox layer.
 */
export function getStyleForLayer(feature, resolution, olLayer, layerId) {
  var evaluateStyle = olLayer.getStyleFunction();
  if (evaluateStyle.length === 3) {
    // @ts-ignore
    return evaluateStyle(feature, resolution, layerId);
  }
  return undefined;
}
export { colorWithOpacity as _colorWithOpacity, evaluateFilter as _evaluateFilter, fromTemplate as _fromTemplate, getValue as _getValue };